export const orejime_apps_external_tracker = {
	name: "external-tracker",
	title: "Nécessaires au bon fonctionnerment du site",
	description: "Ces cookies permettent de garantir des fonctionnalités importantes du site comme la personnalisation de l'affichage (version contrastée). Le site web ne pouvant fonctionner correctement sans eux, ils ne peuvent être désactivés.",
	cookies: ["external-tracker"],
	required: true
}
